import axios from 'axios';
import { Order } from '../models';
import { getAuthHeaders } from '../utils/apiUtils';

const host = process.env.REACT_APP_ApiUrl || '';

export async function fetchOrder(businessUnitId: string): Promise<Order | null> {
  try {
    const url = `${host}/v1/private/business-upgrades/orders?businessUnitId=${businessUnitId}&active=true`;
    const response = await axios.get(url, { headers: getAuthHeaders() });
    return response.data as Order;
  } catch (e) {
    return null;
  }
}

export async function createAndSignOrder(order: Order): Promise<Order> {
  try {
    const url = `${host}/v1/private/business-upgrades/orders`;

    const { contractDetails, ...baseOrder } = order;
    const { termsAndConditionsLink } = contractDetails!;
    const headers = getAuthHeaders();
    let update;
    if (!order.id) {
      update = await axios.post(url, baseOrder, { headers });
    } else {
      update = await axios.put(`${url}/${order.id}`, baseOrder, { headers });
    }

    const orderId = update.data.id;
    const signed = await axios.post(`${url}/${orderId}/sign`, { termsAndConditionsLink }, { headers });
    return signed.data as Order;
  } catch (e) {
    console.log(`Failed to create an order. Reason: ${e.message}`);
    throw e;
  }
}
